import type { FilterState } from "~/lib/filters/types";

type EventMap = {
  "plp:page_viewed": {
    resultCount: number;
    collectionKey: string;
    initialFilters: FilterState;
    initialSort: string;
  };
  "plp:filters_changed": { filters: FilterState };
  "plp:sort_changed": { sort: string };
  "plp:load_more": { pageStart: number; loadedCount: number };
  "plp:all_cleared": void;
  "search:page_viewed": {
    resultCount: number;
    searchQuery: string;
    initialFilters: FilterState;
    initialSort: string;
  };
  "search:filters_changed": { filters: FilterState };
  "search:sort_changed": { sort: string };
  "search:load_more": { pageStart: number; loadedCount: number };
  "search:all_cleared": void;
  "search:autocorrected": { original: string; corrected: string };
  "search:autocorrect_reverted": { original: string; corrected: string };
  "search:did_you_mean_clicked": { suggestion: string };
  "search:redirected": { url: string } | { reason: "unsafe_url" };
  "plp:query_error": { reason: "config" | "query" };
  "search:query_error": { reason: "config" | "query" };
};

type EmitArgs<K extends keyof EventMap> = EventMap[K] extends void
  ? [name: K]
  : [name: K, payload: EventMap[K]];

const EVENT_PREFIX = "dusk:" as const;

const WTO_SPA_CHANGE_EVENT = "wto_spa_change";

const SPA_CHANGE_EVENTS = new Set<keyof EventMap>([
  "plp:page_viewed",
  "plp:filters_changed",
  "plp:sort_changed",
  "plp:load_more",
  "plp:all_cleared",
  "search:page_viewed",
  "search:filters_changed",
  "search:sort_changed",
  "search:load_more",
  "search:all_cleared",
]);

export function emit<K extends keyof EventMap>(...args: EmitArgs<K>): void {
  const [name, payload] = args as [K, EventMap[K] | undefined];
  document.dispatchEvent(
    new CustomEvent(`${EVENT_PREFIX}${name}`, { detail: payload, bubbles: true }),
  );
  if (SPA_CHANGE_EVENTS.has(name)) {
    document.dispatchEvent(
      new CustomEvent(WTO_SPA_CHANGE_EVENT, {
        detail: { event: `${EVENT_PREFIX}${name}`, ...payload },
        bubbles: true,
      }),
    );
  }
}
